import { render, staticRenderFns } from "./motions.vue?vue&type=template&id=09bba2f4"
import script from "./motions.vue?vue&type=script&lang=js"
export * from "./motions.vue?vue&type=script&lang=js"
import style0 from "./motions.vue?vue&type=style&index=0&id=09bba2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports